import generify from './generic'

export const variants = generify('applications-service', 'variants', 'variant')
